import $ from 'jquery';
import {lazyLoad} from '../helpers/lazyLoadHelpers';
import ajaxService from '../services/ajaxService';
import GalleryWithPreview from './GalleryWithPreview';

class RichContentReviews {
	constructor(params) {
		this.galleryElementsSelector = params.galleryElementsSelector || '.item > .review-img';

		this.reviewsData = {
			'page'       : 0,
			'imagesFirst': true,
			...params.reviewsData
		};

		this.getFetchContentUrl = params.getFetchContentUrl;
	}

	init() {
		const $firstImagesCheckbox = $('#fistImages'),
		      $galleryElements     = $(this.galleryElementsSelector);

		if ($galleryElements.length) {
			new GalleryWithPreview({
				'galleryElements': $galleryElements
			});
		}

		$firstImagesCheckbox.on('change', () => {
			this.reviewsData = {
				...this.reviewsData,
				'page'       : 0,
				'imagesFirst': $firstImagesCheckbox.is(':checked')
			};

			this.updateContent();
		});

		$('#reviews .pagination-container').on('click', '.page-link', (ev) => {
			ev.preventDefault();

			const clicked = $(ev.currentTarget);

			this.reviewsData = {
				...this.reviewsData,
				'page'       : clicked.data('pageIndex'),
				'imagesFirst': $firstImagesCheckbox.is(':checked')
			};
			this.updateContent();
		});
	}

	initBadge() {
		const $badge 	      = $('.reviewsRating-badge'),
		      $reviews 	      = $('#reviews'),
		      scrollToReviews = (initial = true) => {
			      let duration =  100;

			      if (initial) {
				      duration =  500;
			      }

			      $('HTML, BODY').animate({
					      'scrollTop': $reviews.offset().top
				      },
				      {
					      duration,
					      'complete': function() {
						      if (initial) {
							      scrollToReviews(false);
						      }
					      }
				      });
		      };

		$badge.on('click', () => {
			scrollToReviews();
		});
	}

	updateContent() {
		ajaxService.sendGet(
			this.getFetchContentUrl(this.reviewsData)
		)
		.then((response) => this._updateContentBlocks(response));
	}

	/**
	 * @param {{
	 * reviewsPaginationBlock?: string,
	 * reviewsListBlock?      : string
	 * }} blocks
	 * @private
	 */
	_updateContentBlocks({reviewsPaginationBlock, reviewsListBlock}) {
		if (reviewsPaginationBlock) {
			$('#reviews .description .full .pagination-container').html(reviewsPaginationBlock);
		}

		if (reviewsListBlock) {
			$('#reviews .description .full .reviews').html(reviewsListBlock);
			lazyLoad({
				'elements_selector': '#reviews .lazy'
			});

			new GalleryWithPreview({
				'galleryElements': $(this.galleryElementsSelector)
			});

			const $reviewsTitle = $('.reviewsTitle');

			if ($reviewsTitle.length) {
				$(document.documentElement).animate(
					{
						'scrollTop': $reviewsTitle.offset().top - 150
					},
					250
				);
			}
		}
	}

}

export default RichContentReviews;